import { render, staticRenderFns } from "./ImagesPreview.vue?vue&type=template&id=2b834dd2&scoped=true"
import script from "./ImagesPreview.vue?vue&type=script&lang=js"
export * from "./ImagesPreview.vue?vue&type=script&lang=js"
import style0 from "./ImagesPreview.vue?vue&type=style&index=0&id=2b834dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b834dd2",
  null
  
)

export default component.exports